// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ICustomPageable } from './ICustomPageable';
import {
    ICustomPageableFromJSON,
    ICustomPageableFromJSONTyped,
    ICustomPageableToJSON,
    ICustomPageableToJSONTyped,
} from './ICustomPageable';
import type { IAccountDto } from './IAccountDto';
import {
    IAccountDtoFromJSON,
    IAccountDtoFromJSONTyped,
    IAccountDtoToJSON,
    IAccountDtoToJSONTyped,
} from './IAccountDto';

/**
 * 
 * @export
 * @interface ICustomPageAccountDto
 */
export interface ICustomPageAccountDto {
    /**
     * 
     * @type {number}
     * @memberof ICustomPageAccountDto
     */
    number?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageAccountDto
     */
    size?: number;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageAccountDto
     */
    last?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageAccountDto
     */
    first?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ICustomPageAccountDto
     */
    empty?: boolean;
    /**
     * 
     * @type {Array<IAccountDto>}
     * @memberof ICustomPageAccountDto
     */
    content?: Array<IAccountDto>;
    /**
     * 
     * @type {ICustomPageable}
     * @memberof ICustomPageAccountDto
     */
    pageable?: ICustomPageable;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageAccountDto
     */
    total_pages?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageAccountDto
     */
    number_of_elements?: number;
    /**
     * 
     * @type {number}
     * @memberof ICustomPageAccountDto
     */
    total_elements?: number;
}

/**
 * Check if a given object implements the ICustomPageAccountDto interface.
 */
export function instanceOfICustomPageAccountDto(value: object): value is ICustomPageAccountDto {
    return true;
}

export function ICustomPageAccountDtoFromJSON(json: any): ICustomPageAccountDto {
    return ICustomPageAccountDtoFromJSONTyped(json, false);
}

export function ICustomPageAccountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICustomPageAccountDto {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'] == null ? undefined : json['number'],
        'size': json['size'] == null ? undefined : json['size'],
        'last': json['last'] == null ? undefined : json['last'],
        'first': json['first'] == null ? undefined : json['first'],
        'empty': json['empty'] == null ? undefined : json['empty'],
        'content': json['content'] == null ? undefined : ((json['content'] as Array<any>).map(IAccountDtoFromJSON)),
        'pageable': json['pageable'] == null ? undefined : ICustomPageableFromJSON(json['pageable']),
        'total_pages': json['totalPages'] == null ? undefined : json['totalPages'],
        'number_of_elements': json['numberOfElements'] == null ? undefined : json['numberOfElements'],
        'total_elements': json['totalElements'] == null ? undefined : json['totalElements'],
    };
}

export function ICustomPageAccountDtoToJSON(json: any): ICustomPageAccountDto {
    return ICustomPageAccountDtoToJSONTyped(json, false);
}

export function ICustomPageAccountDtoToJSONTyped(value?: ICustomPageAccountDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'last': value['last'],
        'first': value['first'],
        'empty': value['empty'],
        'content': value['content'] == null ? undefined : ((value['content'] as Array<any>).map(IAccountDtoToJSON)),
        'pageable': ICustomPageableToJSON(value['pageable']),
        'totalPages': value['total_pages'],
        'numberOfElements': value['number_of_elements'],
        'totalElements': value['total_elements'],
    };
}

